import React, { useCallback } from "react"
import { useAppDispatch } from "@/reducers/hooks"
import { isMacOs, isMobile, isWindows } from "@/utils/detectDevice"
import { updateImageGallery } from "@/reducers/overlaysSlice"
import { mapFileUrlToSameOrigin } from "@/components/message/utils/mapFileToSameOrigin"
import { mobileRoutes, setMobileRoute } from "@/routes/routes"

const SlickAIGalleryLink = ({
  href,
  children,
  messageId,
}: {
  href: string
  children: React.ReactNode
  messageId: string
}) => {
  const dispatch = useAppDispatch()

  const isImage = /\.gif|\.png|\.jpg|\.jpeg/i.test(href)

  const handleImageClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault()
      const isCtrlOrCmdClick =
        event.button === 0 &&
        ((isWindows && event.ctrlKey) || (isMacOs && event.metaKey))
      const isMiddleClick = event.button === 1
      if (isCtrlOrCmdClick || isMiddleClick) {
        window.open(href)
      } else {
        dispatch(
          updateImageGallery({
            visible: true,
            initialImage: mapFileUrlToSameOrigin(href),
            messageId,
          }),
        )
        if (isMobile) {
          setMobileRoute(mobileRoutes.GALLERY)
        }
      }
    },
    [href, dispatch, messageId],
  )

  // Non-image links open in a new tab
  if (!isImage) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  }

  return (
    <a
      data-markdown-image={isImage}
      onClick={handleImageClick}
      href={mapFileUrlToSameOrigin(href)}
    >
      {children}
    </a>
  )
}

export default SlickAIGalleryLink
